module.exports = __webpack_public_path__ + "static/media/endosee-product-img@3x.ca398b71.png";